import { Directive, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[mdLoading]',
})
export class LoadingDirective implements OnChanges {
  @Input() mdLoading: undefined | null | boolean = false;

  @HostBinding('class.md-loading')
  disabled = false;
  @HostBinding('attr.readonly')
  readOnly: null | boolean = null;

  ngOnChanges(changes: SimpleChanges) {
    this.disabled = !!this.mdLoading;
    this.readOnly = this.mdLoading || null;
  }
}
